<template>
  <div>
    <Topo />
    <div class="container-fluid mt-3">
      <div class="container pt-4">
        <h3><i class="fa fa-lock mr-2"></i>Recuperação de Senha</h3>
      </div>
    </div>
    <div class="container mt-content mb-4">
      <div class="row mb-4">
        <div class="col-md-12">
          <b-input-group size="sm" class="mb-2 mr-2" v-on:keyup.enter="onEnterEmail" prepend="Informe seu e-mail:">
            <b-form-input v-model="email" style="max-width: 400px;" />
            <b-input-group-append>
                <b-btn size="sm" text="OK" variant="info" :disabled="trabalhando" @click="VerificaLembrete()">OK</b-btn>
            </b-input-group-append>
          </b-input-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div v-if="trabalhando"><b-spinner small></b-spinner> Trabalhando...</div>
          <div v-if="!trabalhando" v-html="lembrete"></div>
          <div v-if="exibe_botoes" class="mt-5">
            <router-link to="/area-do-medico" class="btn btn-primary mr-3">Ok, me lembrei!</router-link>
            <b-button v-if="trabalhando" variant="danger" disabled><b-spinner small></b-spinner> Trabalhando...</b-button>
            <b-button v-else variant="danger" @click="AtualizaTrocaSenhanoBD()">Não lembro, redefinir senha</b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

/* eslint-disable no-eval */

import Topo from '@/components/Topo.vue'
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'

export default {
  name: 'Senha',
  components: { Topo },
  data: function () {
    return {
      qt: 0,
      nome: '',
      id_crip: '',
      email: '',
      lembrete: '',
      trabalhando: false,
      exibe_botoes: false,
      dados_email: {},
      vares: {}
    }
  },
  methods: {
    onEnterEmail () {
      this.VerificaLembrete()
    },
    VerificaLembrete () {
      this.trabalhando = true
      axios.get(`${baseApiUrl}/lembrete/${this.email}`)
        .then(res => {
          this.qt = res.data.qt
          this.nome = res.data.nome
          this.id_crip = res.data.id_crip

          if (res.data.qt === 0) {
            this.lembrete = `<b><i class='text-danger'>Não foi possível localizar o e-mail digitado em nosso banco de dados.<br />Caso não se recorde do email cadastrado, envie um email com seus dados para</i>&nbsp;<i class='text-primary'><a href='mailto:suporte-sbo@wgs.com.br'>suporte-sbo@wgs.com.br</a></i><br /><i class='text-danger'>No assunto informe:</i>&nbsp;<i class='text-primary'>Recuperação de e-mail cadastrado</i></b>`
          } else {
            if (res.data.lembrete === '' || res.data.lembrete === 'NULL') {
              this.lembrete = `<i>Seu lembrete de senha é:</i>&nbsp;<b>Nenhum lembrete cadastrado.</b>`
            } else {
              this.lembrete = `<i>Seu lembrete de senha é:</i>&nbsp;<b>${res.data.lembrete}</b>`
            }
          }
          if (this.qt) {
            this.exibe_botoes = true
          } else {
            this.exibe_botoes = false
          }
          this.trabalhando = false
        })
        .catch(err => {
          showError(err)
          this.exibe_botoes = false
          this.trabalhando = false
        })
    },
    AtualizaTrocaSenhanoBD () {
      this.trabalhando = true
      const TrocaSenha = {
        troca_senha: 1
      }
      axios.put(`${baseApiUrl}/troca_senha/${this.id_crip}`, TrocaSenha)
        .then(() => {
          this.EnviaEmail()
        })
        .catch(err => {
          this.trabalhando = false
          showError(err)
        })
    },
    EnviaEmail () {
      this.dados_email.email = this.email

      // SUBSTITUI CAMPOS DE MESCLAGEM
      let strbusca = eval('/' + '{Nome}' + '/g')
      this.dados_email.mensagem = this.dados_email.mensagem.replace(strbusca, this.nome)

      strbusca = eval('/' + '{E-mail}' + '/g')
      this.dados_email.mensagem = this.dados_email.mensagem.replace(strbusca, this.email)

      strbusca = eval('/' + '{IDCrip}' + '/g')
      this.dados_email.mensagem = this.dados_email.mensagem.replace(strbusca, this.id_crip)

      axios.post(`${baseApiUrl}/emailsg`, this.dados_email)
        .then(() => {
          // this.$toasted.global.defaultSuccess({msg: "E-mail de recuperação de senha enviado com sucesso!"})
          this.lembrete = `<b><i class="fa fa-check text-success" aria-hidden="true"></i>&nbsp;<i class="text-success">E-mail de recuperação de senha enviado com sucesso!</i></b>`
          this.trabalhando = false
        })
        .catch(err => {
          showError(err)
          this.trabalhando = false
        })
    },
    CarregaDadosParaEnviodeEmail () {
      axios.get(`${baseApiUrl}/pega_dados_para_envio_de_email/3`)
        .then(res => {
          this.dados_email = res.data
          this.dados_email.id_crip = ''
          this.dados_email.tipo_email = ''
        })
        .catch(showError)
    }
  },
  mounted () {
    this.CarregaDadosParaEnviodeEmail()
  }
}
</script>
